import { isNumeric } from '80.quickConnect.Core/helpers/common';
import { NumericDesc } from '90.quickConnect.Models/models';

const mapNumericDesc = (field: NumericDesc): NumericDesc => {
  const doubleDefault = isNumeric(field.defaultValue) ? field.defaultValue : undefined;
  return {
    isVertical: field.isVertical,
    min: field.min,
    max: field.max,
    value: field.value?.toString() ?? doubleDefault,
    defaultValue: doubleDefault,
  } as NumericDesc;
};

export default mapNumericDesc;
